import React from 'react'

type Props = {
    type: number
}

export default function CustomFieldIcon(props: Props) {

    const customField = gd.const.customFields[props.type]

    return (
        <div className="details-big-icon">
            <div className={Classes("ui5-ico-custom-field s-72", customField.icon, "bg-{0}".f(gd.const.customFields.getGroupColor(customField.group)))}/>
        </div>
    );
}
